import AppHttp from '@/lib/AppHttp';
import ResourceHttp from '@/lib/ResourceHttp';
import {
    CreateEquipmentDowntimeCodeCommand, CreateHazardCategoryCommand,
    EquipmentDowntimeCodeViewModel, HazardCategoryViewModel, ReorderEquipmentDowntimeCodesCommand,
    ReorderHazardCategoriesCommand,
    UpdateEquipmentDowntimeCodeCommand, UpdateHazardCategoryCommand
} from '@/models/api';

export class Hazards {
    private resource: string = 'Hazards';


    public async getCategories(departmentId: string): Promise<HazardCategoryViewModel[]> {
        const response = await AppHttp.get(`${this.resource}/${departmentId}/Categories`);
        const data = response ? response.data : [];
        return data;
    }

    public async updateCategory(departmentId: string, command: UpdateHazardCategoryCommand) {
        const response = await AppHttp.put(`${this.resource}/${departmentId}/Categories/${command.id}`, command);
        const data = response ? response.data : null;
        return data;
    }

    public async createCategory(departmentId: string, command: CreateHazardCategoryCommand) {
        const response = await AppHttp.post(`${this.resource}/${departmentId}/Categories`, command);
        const data = response ? response.data : null;
        return data;
    }

    public async archiveCategory(departmentId: string, id: string) {
        const response = await AppHttp.put(`${this.resource}/${departmentId}/Categories`, null);
        const data = response ? response.data : null;
        return data;
    }

    public async restoreCategoryFromArchive(departmentId: string, id: string) {
        const response = await AppHttp.put(`${this.resource}/${departmentId}/Categories/${id}/Archive`, null);
        const data = response ? response.data : null;
        return data;
    }

    public async exportCategories(departmentId: string) {
        const response = await AppHttp.get(`${this.resource}/${departmentId}/Categories/Export`);
        const data = response ? response.data : null;
        return data;
    }

    public async importCategories(departmentId: string, file: any) {
        const response = await AppHttp.postWithFiles(`${this.resource}/${departmentId}/Categories/Import`, {}, [file]);
        const data = response ? response.data : null;
        return data;
    }

    public async reorderCategories(departmentId: string, command: ReorderHazardCategoriesCommand) {
        const response = await AppHttp.post(`${this.resource}/${departmentId}/Categories/Reorder`, command);
        const data = response ? response.data : null;
        return data;
    }
}

export default new Hazards();